<template>
    <v-switch v-model="theme" append-icon="mdi-weather-night" color="secondary" true-value="dark" false-value="light"
        label="Dark mode" :loading="loading" :disabled="disabled" @update:modelValue="change()" />
</template>

<script>
export default {
    name: 'DarkModeSwitch',
    data() {
        return {
            loading: false,
            disabled: false,
            theme: null,
        }
    },
    methods: {
        async change() {

            //Set the loading state and disabled state to true when the switch changes
            this.loading = true;
            this.disabled = true;

            //Add a delay on 1 second
            setTimeout(() => {

                //Update the Vuetify theme
                this.$vuetify.theme.global.name = this.theme;

                //Set the theme in a cookie
                this.$cookies.set('theme', this.theme, '1y');

                //Set the loading state and disabled state to false when the theme updates
                this.loading = false;
                this.disabled = false;

            }, 1000);
        }
    },
    created() {

        //Set the theme variable for v-model on the switch
        this.theme = this.$vuetify.theme.global.name;
    },
}
</script>